import React from 'react';
import '../../styles/SolucionesPublicitarias.css';
import * as Icons from 'react-icons/fa6';

const GeoreferencedCampaigns = () => {
    return (
        <section className="georeferenced-campaigns-section py-5">
            <div className="container">
                <div className='row justify-content-center align-items-center m-1'>
                    <div className='col-md-7 col-1-georeferenced-campaigns mt-5'>
                        <div className='pb-2' data-aos="fade-up">
                            <h2 className="title"><span>Campañas <br /></span>Georeferenciadas</h2>
                        </div>

                        <div className='pb-2' data-aos="fade-up">
                            <p>
                                <span>En BeHealth realizamos campañas especiales con la posibilidad de georeferenciarlas</span> a
                                lugares específicos. Estas campañas incluyen cápsulas de contenido diseñadas para replicarse
                                en redes sociales, amplificando el alcance y logrando una cobertura más efectiva.
                            </p>
                        </div>

                        <div className='row align-items-center row-white p-3'>
                            <div className='col-lg-3 col-md-12 text-center p-3' data-aos="flip-right">
                                <Icons.FaLocationDot style={{ color: 'red', fontSize: '120px', filter: 'drop-shadow(2px 2px 3px rgba(0,0,0,0.4))' }} />
                            </div>

                            <div className='col-lg-9 col-md-12' data-aos="fade-up">
                                <p>
                                    Además, <span>implementamos estrategias de retargeting</span> para seguir impactando al público
                                    más interesado, maximizando resultados y mejorando la recordación en los lugares clave.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-5 text-center mt-5' data-aos="flip-right">
                        <img src="assets/campanas-georeferenciadas.png" alt="" className='img-fluid img-filter' />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GeoreferencedCampaigns;